/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TestCaseVisibility } from './TestCaseVisibility';
import {
    TestCaseVisibilityFromJSON,
    TestCaseVisibilityFromJSONTyped,
    TestCaseVisibilityToJSON,
    TestCaseVisibilityToJSONTyped,
} from './TestCaseVisibility';
import type { TestCaseStatus } from './TestCaseStatus';
import {
    TestCaseStatusFromJSON,
    TestCaseStatusFromJSONTyped,
    TestCaseStatusToJSON,
    TestCaseStatusToJSONTyped,
} from './TestCaseStatus';

/**
 * 
 * @export
 * @interface TestCaseRead
 */
export interface TestCaseRead {
    /**
     * 
     * @type {string}
     * @memberof TestCaseRead
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof TestCaseRead
     */
    driver_code: string;
    /**
     * 
     * @type {number}
     * @memberof TestCaseRead
     */
    points: number;
    /**
     * 
     * @type {TestCaseVisibility}
     * @memberof TestCaseRead
     */
    visibility?: TestCaseVisibility;
    /**
     * 
     * @type {string}
     * @memberof TestCaseRead
     */
    id: string;
    /**
     * 
     * @type {TestCaseStatus}
     * @memberof TestCaseRead
     */
    status: TestCaseStatus;
    /**
     * 
     * @type {string}
     * @memberof TestCaseRead
     */
    official_output_id: string | null;
}



/**
 * Check if a given object implements the TestCaseRead interface.
 */
export function instanceOfTestCaseRead(value: object): value is TestCaseRead {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('driver_code' in value) || value['driver_code'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('official_output_id' in value) || value['official_output_id'] === undefined) return false;
    return true;
}

export function TestCaseReadFromJSON(json: any): TestCaseRead {
    return TestCaseReadFromJSONTyped(json, false);
}

export function TestCaseReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCaseRead {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'driver_code': json['driver_code'],
        'points': json['points'],
        'visibility': json['visibility'] == null ? undefined : TestCaseVisibilityFromJSON(json['visibility']),
        'id': json['id'],
        'status': TestCaseStatusFromJSON(json['status']),
        'official_output_id': json['official_output_id'],
    };
}

export function TestCaseReadToJSON(json: any): TestCaseRead {
    return TestCaseReadToJSONTyped(json, false);
}

export function TestCaseReadToJSONTyped(value?: TestCaseRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'driver_code': value['driver_code'],
        'points': value['points'],
        'visibility': TestCaseVisibilityToJSON(value['visibility']),
        'id': value['id'],
        'status': TestCaseStatusToJSON(value['status']),
        'official_output_id': value['official_output_id'],
    };
}

